module.exports = __webpack_public_path__ + "img/fatherhood_12.df476b31.jpg";